import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=2cc109c7&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=2cc109c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc109c7",
  null
  
)

export default component.exports